<template>
  <div class="base">
    <inside-header title="萧十一郎" />
    <div class="main">
      <div class="list">
        <div class="item other-party">
          <div class="header-img">
            <img src="@/assets/test-header.png" alt="">
          </div>
          <div class="content">
            在吗？
          </div>
        </div>
        <div class="item my-item">
          <div class="header-img">
            <img src="@/assets/test-header.png" alt="">
          </div>
          <div class="content">
            干嘛？
          </div>
        </div>
        <div class="item my-item">
          <div class="header-img">
            <img src="@/assets/test-header.png" alt="">
          </div>
          <div class="content">
            看你想我没
          </div>
        </div>
        <div v-for="(num, index) in 10" :key="index" class="item other-party">
          <div class="header-img">
            <img src="@/assets/test-header.png" alt="">
          </div>
          <div class="content">
            才没想你呢
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="send-area">
        <a-input class="input-area" />
        <a-button class="send-btn" type="primary">
          发送
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'

export default {
  name: 'TutorPay',
  components: {
    InsideHeader
  },
  data() {
    return {
    }
  },
  created() {
    // this.loadData(this.id, this.$route.query)
  },
  methods: {
    // this.loadData(this.id, this.$route.query)
  }
}
</script>
<style lang="stylus" scoped>
  .base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
  }

  .main {
    padding: 15px;
    padding-bottom: 60px;

    .list {
      .item {
        padding: 9px 0;
        overflow: hidden;

        .header-img {
          width: 13%;

          img {
            width: 40px;
            height: 40px;
          }
        }

        .content {
          padding: 8px 12px;
          max-width: 70%;
          background-color: #f6f6f6;
          border-radius: 5px;

          font-family: PingFang-SC-Medium;
          font-size: 16px;
          line-height: 24px;
          color: #333333;
        }
      }

      .other-party {

        .header-img {
          float: left;
        }

        .content {
          float: left;
          margin-left: 5px;
        }
      }

      .my-item {
        .content {
          margin-right: 5px;
          float: right;
        }

        .header-img {
          float: right;
        }
      }

    }
  }

  .bottom {
    .send-area {
      width: 100%;
      position: fixed;
      bottom: 0px;
      padding: 8px 15px;
      background-color: #f7f7f7;

      .input-area {
        width: 75%;
        height: 40px;
        background-color: #ffffff;
        border-radius: 10px;
      }
    }

    .send-btn {
      width: 20%;
      height: 40px;
      background-color: #ff5c00;
      border-radius: 10px;
      margin-left: 10px;
    }
  }
</style>
